import { ComponentStyleConfig } from '@chakra-ui/react'

export const Menu: ComponentStyleConfig = {
  baseStyle: {
    list: {
      rounded: 'xl',
      border: 'none',
      shadow: '2xl',
      padding: 5,
    },
    item: {
      marginTop: 2,
      fontWeight: '500',
      _first: {
        marginTop: 0,
      },
      _hover: {
        backgroundColor: 'none',
      },
      _focus: {
        backgroundColor: 'transparent',
      },
      _selected: {
        backgroundColor: 'transparent',
      },
      _disabled: {
        color: 'rgba(0, 0, 0, .2)',
      },
    },
  },
}
